import BankManagement from "./bank-management.page";

export default BankManagement;
